import 'core-js' //
import 'classlist-polyfill'
import cssVars from 'css-vars-ponyfill'
import '@/utils/analistic'
import { isMobile, goToLoginPage } from '@/utils'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Cookies from 'js-cookie'

import vueMoment from 'vue-moment'
import moment from 'moment-timezone'

// origin polyfill
if (!window.location.origin) {
  window.location.origin =
    window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '')
}
// addComma
Number.prototype.addComma = function() {
  return this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
String.prototype.addComma = Number.prototype.addComma

// document.domain = 'nexon.com'

cssVars()

Cookies.set('isMobile', isMobile, { domain: 'nexon.com' })

Vue.use(vueMoment, { moment })

// console.log(Cookies.get('NPP'), Cookies.get('_ifwt'))

let needMoveInsignLogin = false
if (Cookies.get('NPP') && !Cookies.get('_ifwt')) {
  needMoveInsignLogin = true
} else {
  needMoveInsignLogin = false
}

const vueControl = () => {
  window.onStartInfaceAuth = () => {
    if (needMoveInsignLogin) {
      goToLoginPage()
    }
    new Vue({
      el: '#app',
      store,
      router,
      template: '<App/>',
      components: {
        App
      },
      created() {
        // for IE
        const msie = document.documentMode
        if (msie && msie < 11) {
          alert(
            `현재 사용 중인 Internet Explorer ${msie}은 제조사의 기술 지원이 종료된 브라우저입니다.\n해당 페이지를 정상적으로 표시하지 않을 수 있습니다.`
          )
        }
      }
    })
  }
  window.onErrorInfaceAuth = error => {
    console.error('onErrorInfaceAuth', error)
  }
}

vueControl()
